<template>
  <div
    :class="[
      'comment-item-wrap  flex',
      isFirstComment ? 'u-border-top u-p-t-32 u-p-b-32' : 'u-p-b-32',
    ]"
  >
    <div class="choiceness" v-if="isFirstComment && item.choicenessFlag">
      <img src="@/assets/H5/play/choiceness.png" alt="" />
    </div>
    <div :class="['avatar', isFirstComment ? 'u-m-r-20' : 'u-m-r-16']">
      <van-image class="tx-img" round :src="item.fromUserHeadImg" />
    </div>
    <div class="main flex-column">
      <div class="name-time flex flex-a-c">
        <div
          :class="[
            'name van-ellipsis u-m-r-24',
            isFirstComment ? 'first-w' : 'second-w',
          ]"
        >
          {{ item.roleType == 3 ? "管理员" : item.fromUserName }}
        </div>
        <!-- 1.讲师 2.学员 3.官方 -->
        <div class="role-type" v-if="item.roleType == 3">官方</div>
        <!-- <div class="time">{{ item.createTime }}</div> -->
      </div>
      <div class="content u-m-b-16">
        <text class="reply" v-if="!isFirstComment">回复</text>
        <text class="to-name u-m-l-8 u-m-r-8" v-if="!isFirstComment"
          >@{{ item.toUserName }}</text
        >
        <text>{{ item.content }}</text>
      </div>
      <div class="btns flex">
        <div class="time">{{ item.createTime }}</div>
        <div :class="['flex', isFirstComment ? 'action-one' : 'action']">
          <!-- class="u-m-r-80 flex flex-a-c" -->
          <div
            class="flex flex-a-c"
            @click="like"
            :class="item.likeStatus ? 'like-text' : 'text'"
          >
            <van-icon class="good-job u-m-r-10" name="good-job" />
            <div>{{ item.likeCount ? item.likeCount : "赞" }}</div>
          </div>
          <div class="flex flex-a-c" @click="reply">
            <van-icon class="chat u-m-r-10" name="chat" />
            <div class="text">回复</div>
          </div>
        </div>
      </div>
      <div
        class="second-comment"
        v-if="item.pageComment && item.pageComment.records.length > 0"
      >
        <Comment-Items
          v-for="(children, index) of item.pageComment.records"
          :key="children.id"
          :originItem="children"
          :index="index"
          :isFirstComment="false"
          @publishComment="handlePublishComment"
        ></Comment-Items>
        <div
          class="total-comment"
          v-if="item.pageComment.total > item.pageNo * item.pageSize"
        >
          <text class="tip">共{{ item.pageComment.total }}条回复，</text>
          <text class="load-more" @click="getChildComments">点击查看</text>
        </div>
      </div>
      <!-- <div class="btns flex">
        <div
          class="u-m-r-80 flex flex-a-c"
          @click="like"
          :class="item.likeStatus ? 'like-text' : 'text'"
        >
          <van-icon class="u-m-r-10" name="good-job" :size="14" />
          <div>{{ item.likeCount ? item.likeCount : "赞" }}</div>
        </div>
        <div class="flex flex-a-c" @click="reply">
          <van-icon class="u-m-r-10" name="chat" :size="14" />
          <div class="text">回复</div>
        </div>
      </div> -->
      <!-- 回复框 -->
      <div v-if="item.isShowReply" class="reply-box flex u-m-t-20">
        <div class="u-m-r-24">
          <van-image class="tx-img" round :src="user.imageUrl" />
        </div>
        <div class="main">
          <div class="box u-m-b-16">
            <textarea
              v-model="item.replyComment"
              class="textarea"
              :maxlength="100"
              :placeholder="`回复 @ ${
                item.roleType == 3 ? '管理员' : item.fromUserName
              }`"
            ></textarea>
            <!-- <div class="tip">{{ item.replyComment.length }}/100</div> -->
          </div>
          <div class="comment-btns flex flex-j-b flex-a-c">
            <van-checkbox
              v-model="item.isAnonymous"
              shape="square"
              checked-color="#0f3cc6"
              >匿名回复</van-checkbox
            >
            <div class="reply-btn" @click="publishComment1">
              <!-- <van-button
                type="primary"
                size="mini"
                @click="publishComment1"
                color="#0f3cc6"
                >回复</van-button
              > -->
              回复
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Toast } from "vant";
import { defineComponent, onMounted, ref, watch } from "vue";

import { dealCommentLike, getCommentChildList } from "@/api/play";
export default defineComponent({
  name: "Comment-Items",
  props: {
    originItem: Object,
    index: Number,
    isFirstComment: { type: Boolean, default: true },
    applyStatus: Number,
  },
  setup(props, { emit }) {
    const store = useStore();
    const router = useRouter();
    let user = ref({});
    let item = ref({});
    // 点赞
    const like = () => {
      if (!user.value.phone) {
        //游客 -> 去绑定手机号
        const _return_url = encodeURIComponent(location.href);
        router.push({ name: "BindPhone", query: { _return_url } });
        return false;
      }
      dealCommentLike({ commentId: item.value.id })
        .then(() => {
          let message = "";
          if (item.value.likeStatus) {
            item.value.likeCount--;
            message = "取消点赞成功";
          } else {
            item.value.likeCount++;
            message = "点赞成功";
          }
          item.value.likeStatus = !item.value.likeStatus;
          Toast.success(message);
        })
        .catch((e) => {
          console.log(e);
          Toast.fail("操作失败");
        });
    };
    const reply = () => {
      item.value.isShowReply = !item.value.isShowReply;
    };
    const publishComment1 = () => {
      publishComment2(item.value, props.isFirstComment, props.index);
    };
    const handlePublishComment = (val) => {
      const { item, isFirstComment } = val;
      publishComment2(item, isFirstComment, props.index);
    };
    const publishComment2 = (item, isFirstComment, index) => {
      if (item.replyComment.length <= 0) {
        Toast.fail("请输入留言内容");
        return;
      }
      emit("publishComment", { item, isFirstComment, index });
    };
    const getChildComments = async () => {
      item.value.pageNo++;
      const params = {
        pageNo: item.value.pageNo,
        pageSize: item.value.pageSize,
        commentId: item.value.id,
      };
      const { results } = await getCommentChildList(params);
      const records = formatData(results.records);
      item.value.pageComment.records =
        item.value.pageComment.records.concat(records);
    };
    const formatData = (records) => {
      records.forEach((item) => {
        item.isAnonymous = false;
        item.isShowReply = false;
        item.replyComment = "";
        item.pageNo = 1;
        item.pageSize = 3;
      });

      return records;
    };
    watch(props.originItem, (newValue) => {
      item.value = newValue;
    });
    onMounted(async () => {
      item.value = props.originItem;
      user.value = store.state.user.userinfo;
    });
    return {
      user,
      item,
      like,
      reply,
      handlePublishComment,
      publishComment1,
      publishComment2,
      getChildComments,
      formatData,
    };
  },
});
</script>

<style lang="less" scoped>
.u-border-top {
  border-top: 1px solid #e4e7ed;
}

.comment-item-wrap {
  position: relative;
  /deep/ .van-checkbox__label {
    line-height: 26px;
    height: 26px;
    margin-left: 5px;
  }
  .choiceness {
    position: absolute;
    top: 10px;
    right: 0;
    width: 80px;
    height: 34px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .tx-img {
    width: 28px;
    height: 28px;
  }
  .main {
    flex-grow: 1;
    .name-time {
      height: 28px;
      line-height: 28px;
      font-size: 14px;
      font-weight: 400;
      .name {
        color: rgba(0, 0, 0, 0.65);
      }
      .first-w {
        max-width: 120px;
      }
      .second-w {
        max-width: 60px;
      }
      .time {
        color: rgba(0, 0, 0, 0.4);
      }
      .role-type {
        height: 16px;
        line-height: 16px;
        background: #e9edfd;
        border-radius: 4px;
        font-size: 12px;
        color: #254ef4;
        text-align: center;
        padding: 0 6px;
      }
    }
    .content {
      font-size: 14px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
      word-break: break-all;
      .to-name {
        color: #6f9fff;
      }
      .reply {
        color: rgba(0, 0, 0, 0.4);
      }
    }
    .second-comment {
      margin-top: 12px;
      background-color: rgba(0, 0, 0, 0.04);
      border-radius: 2px;
      padding: 12px 12px 0;
      .total-comment {
        height: 22px;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        margin-bottom: 16px;
      }
      .tip {
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.4);
      }
      .load-more {
        font-size: 14px;
        font-weight: 400;
        color: #6f9fff;
      }
    }
    .btns {
      font-size: 12px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.4);
      line-height: 18px;
      height: 18px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .like-text {
        color: #f77b00;
      }
      .text {
        color: rgba(0, 0, 0, 0.4);
      }
      .time {
        color: rgba(0, 0, 0, 0.4);
      }
      .action {
        width: 112px;
        display: flex;
        justify-content: space-between;
      }
      .action-one {
        width: 122px;
        display: flex;
        justify-content: space-between;
      }
      .good-job,
      .chat {
        font-size: 14px;
      }
    }
    .reply-box {
      width: 100%;
      .main {
        width: 100%;
        .box {
          // padding: 4px 8px;
          background-color: #f7f8fa;
          border-radius: 8px;
          .textarea {
            box-sizing: border-box;
            width: 100%;
            height: 65px;
            border: 1px solid #0f3cc6;
            border-radius: 2px;
            background-color: #f7f8fa;
            resize: none;
            font-size: 14px;
            &::-webkit-input-placeholder {
              color: #999999;
              font-size: 14px;
            }
          }
          .tip {
            font-size: 12px;
            font-weight: 400;
            color: #999999;
            text-align: right;
          }
        }
        /deep/ .comment-btns {
          font-size: 12px;
          color: #606266;
          line-height: 24px;
          .van-checkbox__icon {
            font-size: 15px;
          }
          .reply-btn {
            padding: 5px 18px;
            background: #0f3cc6;
            border-radius: 2px;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
